import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="notificationService.notification$ | async as notification"
         class="fixed bottom-4 right-4 z-50 animate-slide-up"
         [ngClass]="{
           'bg-green-900 text-green-200': notification.type === 'success',
           'bg-red-900 text-red-200': notification.type === 'error',
           'bg-blue-900 text-blue-200': notification.type === 'info'
         }">
      <div class="rounded-lg p-4 shadow-lg ring-1"
           [ngClass]="{
             'ring-green-800/50': notification.type === 'success',
             'ring-red-800/50': notification.type === 'error',
             'ring-blue-800/50': notification.type === 'info'
           }">
        <p class="text-sm font-medium">
          {{ notification.message }}
        </p>
      </div>
    </div>
  `,
  styles: [`
    .animate-slide-up {
      animation: slide-up 0.3s ease-out;
    }
    @keyframes slide-up {
      from {
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  `]
})
export class NotificationComponent {
  constructor(public notificationService: NotificationService) {}
} 